import { motion } from "framer-motion";

export function StatCard({ label, value, sub, icon: Icon, size = "md", index = 0, testId }) {
  const isLg = size === "lg";
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className={`stat-dark relative overflow-hidden ${isLg ? "p-7" : "p-5"}`}
    >
      <div className="pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-white/[0.04] blur-2xl" />
      <div className="flex items-center justify-between">
        <p className={`font-medium text-neutral-400 ${isLg ? "text-sm" : "text-xs"}`}>{label}</p>
        {Icon && <Icon className={`text-neutral-500 ${isLg ? "h-5 w-5" : "h-4 w-4"}`} />}
      </div>
      <p className={`num-display mt-3 font-extrabold text-white ${isLg ? "text-4xl sm:text-5xl" : "text-2xl"}`}>
        {value}
      </p>
      {sub && <p className="mt-1 text-xs text-neutral-500">{sub}</p>}
    </motion.div>
  );
}
